import "./AddVenue.scss";

import chevronLeft from "../../assets/images/icons/chevron-left.svg";
import chevronDown from "../../assets/images/icons/chevron-down.svg";
import addPhoto from "../../assets/images/icons/add-photo.svg";
import checkMark from "../../assets/images/icons/check-mark.svg";

import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Dropdown from "../../components/Dropdown/Dropdown";

import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import TopNav from "../../components/TopNav/TopNav";
import SideBar from "../../components/SideBar/SideBar";

function AddVenue() {
    const navigate = useNavigate();

    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [showDressCodeDropdown, setShowDressCodeDropdown] = useState(false);
    const [showMusicDropdown, setShowMusicDropdown] = useState(false);

    const [profilePic, setProfilePic] = useState(null);

    const fileInputRef = useRef(null);

    const handleFileUpload = () => {
        const something = fileInputRef.current.click();
        console.log("this is what happens when i upload a file: ", something);
    };

    //DROP DOWN ===================================================================

    const catDropdownRef = useRef(null);
    const dressDropdownRef = useRef(null);
    const musicDropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (catDropdownRef.current && !catDropdownRef.current.contains(event.target)) {
                setShowCategoryDropdown(false);
            }
            if (dressDropdownRef.current && !dressDropdownRef.current.contains(event.target)) {
                setShowDressCodeDropdown(false);
            }
            if (musicDropdownRef.current && !musicDropdownRef.current.contains(event.target)) {
                setShowMusicDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    //FORM INPUTS =================================================================

    const [selectedCats, setSelectedCats] = useState([]);
    const [selectedDress, setSelectedDress] = useState("Choose dress code");
    const [selectedMusic, setSelectedMusic] = useState([]);

    const [newVenueName, setNewVenueName] = useState("");
    const [newVenueAddress, setNewVenueAddress] = useState("");
    const [newVenueHours, setNewVenueHours] = useState("");
    const [newVenuePhone, setNewVenuePhone] = useState("");
    const [newVenueSite, setNewVenueSite] = useState("");
    const [newVenueEmail, setNewVenueEmail] = useState("");
    const [newVenuePrice, setNewVenuePrice] = useState("");
    const [newVenueAbout, setNewVenueAbout] = useState("");
    const [newVenueLong, setNewVenueLong] = useState("");
    const [newVenueLat, setNewVenueLat] = useState("");

    //ADDING USER ================================================================

    function handleAddVenue(event) {
        event.preventDefault();

        const newVenue = {
            id: uuidv4(),
            name: newVenueName,
            address: newVenueAddress,
            phone: newVenuePhone,
            hours: newVenueHours,
            url: newVenueSite,
            email: newVenueEmail,
            price: newVenuePrice,
            about: newVenueAbout,
            category: selectedCats[0],
            tags: selectedCats,
            lat: newVenueLat,
            lng: newVenueLong,
            followers: 0,
            checkIns: 0,
            image: "",
            rating_count: "0",
            star_count: "0",
            country: "US",
            state: "Florida",
            city: "Miami",
            dress: selectedDress,
            music: selectedMusic,
        };

        const addVenue = async () => {
            try {
                await axios.post("https://zona-app-server-584d567d8841.herokuapp.com/venues", newVenue);
                navigate("/venues");
            } catch (err) {
                console.log(`unable to add venue. this was the error: ${err}`);
            }
        };
        addVenue();
    }

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                <article style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <section className="add-venue">
                        <div className="add-venue__top">
                            <Link to="/venues">
                                <img
                                    src={chevronLeft}
                                    className="add-venue__top-icon"
                                    alt="chevron pointing left"
                                ></img>
                            </Link>
                            <h1 className="add-venue__top-heading">Adding new venue</h1>
                        </div>

                        <form onSubmit={handleAddVenue} className="add-venue__form">
                            <section className="add-venue__form--left">
                                <div className="add-venue__form-block">
                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venueName" className="add-venue__form-block-group-label">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            name="venueName"
                                            className="add-venue__form-block-group-input"
                                            value={newVenueName}
                                            onChange={(event) => setNewVenueName(event.target.value)}
                                            placeholder="Enter name"
                                            required
                                        />
                                    </div>

                                    <div className="add-venue__form-block-group">
                                        <p className="add-venue__form-block-group-label">Category</p>
                                        <div ref={catDropdownRef}>
                                            <div
                                                onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                                                className="add-venue__form-block-group-input add-venue__form-block-group-input--special"
                                            >
                                                <p className="add-venue__form-block-group-input-text">
                                                    {selectedCats ? "Choose category" : "there are selected cats"}
                                                </p>
                                                <img
                                                    className="add-venue__form-block-group-input-icon"
                                                    src={chevronDown}
                                                    alt="chevron down"
                                                ></img>
                                            </div>
                                            {showCategoryDropdown && (
                                                <Dropdown
                                                    type={"checkbox"}
                                                    data={[
                                                        "Clubs",
                                                        "Lounge",
                                                        "Pool Hall",
                                                        "Sports Bars",
                                                        "Dive Bars",
                                                        "Hookah Lounge",
                                                        "Karaoke",
                                                        "Drag Queen Show",
                                                        "Dinner Party",
                                                        "Live Music",
                                                        "Outdoor Venues",
                                                        "Industry Night",
                                                        "18+",
                                                        "21+",
                                                    ]}
                                                    setter={setSelectedCats}
                                                    valueSet={selectedCats}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="add-venue__form-block">
                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venueAddress" className="add-venue__form-block-group-label">
                                            Address
                                        </label>
                                        <input
                                            type="address"
                                            name="venueAddress"
                                            className="add-venue__form-block-group-input"
                                            venue={newVenueAddress}
                                            onChange={(event) => setNewVenueAddress(event.target.value)}
                                            placeholder="Enter address"
                                            required
                                        />
                                    </div>

                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venueHours" className="add-venue__form-block-group-label">
                                            Hours of operation
                                        </label>
                                        <input
                                            type="text"
                                            name="venueHours"
                                            className="add-venue__form-block-group-input"
                                            value={newVenueHours}
                                            onChange={(event) => setNewVenueHours(event.target.value)}
                                            placeholder="Enter hours"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="add-venue__form-block">
                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venueLong" className="add-venue__form-block-group-label">
                                            Longitude
                                        </label>

                                        <input
                                            type="text"
                                            name="venueLong"
                                            className="add-venue__form-block-group-input"
                                            value={newVenueLong}
                                            onChange={(event) => setNewVenueLong(event.target.value)}
                                            placeholder="Enter longitude"
                                            required
                                        />
                                    </div>

                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venueLat" className="add-venue__form-block-group-label">
                                            Latitude
                                        </label>

                                        <input
                                            type="text"
                                            name="venueLat"
                                            className="add-venue__form-block-group-input"
                                            value={newVenueLat}
                                            onChange={(event) => setNewVenueLat(event.target.value)}
                                            placeholder="Enter latitude"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="add-venue__form-block">
                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venuePhone" className="add-venue__form-block-group-label">
                                            Phone
                                        </label>
                                        <input
                                            type="phone"
                                            name="venuePhone"
                                            className="add-venue__form-block-group-input"
                                            value={newVenuePhone}
                                            onChange={(event) => setNewVenuePhone(event.target.value)}
                                            placeholder="Enter phone"
                                            required
                                        />
                                    </div>

                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venueWebsite" className="add-venue__form-block-group-label">
                                            Website
                                        </label>
                                        <input
                                            type="text"
                                            name="venueWebsite"
                                            className="add-venue__form-block-group-input"
                                            value={newVenueSite}
                                            onChange={(event) => setNewVenueSite(event.target.value)}
                                            placeholder="Enter website"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="add-venue__form-block">
                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venueEmail" className="add-venue__form-block-group-label">
                                            E-mail
                                        </label>
                                        <input
                                            type="email"
                                            name="venueEmail"
                                            className="add-venue__form-block-group-input"
                                            value={newVenueEmail}
                                            onChange={(event) => setNewVenueEmail(event.target.value)}
                                            placeholder="Enter e-mail"
                                            required
                                        />
                                    </div>

                                    <div className="add-venue__form-block-group">
                                        <label htmlFor="venuePrice" className="add-venue__form-block-group-label">
                                            Price
                                        </label>
                                        <input
                                            type="text"
                                            name="venuePrice"
                                            className="add-venue__form-block-group-input"
                                            value={newVenuePrice}
                                            onChange={(event) => setNewVenuePrice(event.target.value)}
                                            placeholder="Enter price"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="add-venue__form-block">
                                    <div className="add-venue__form-block-group">
                                        <p className="add-venue__form-block-group-label">Dress-code</p>

                                        <div ref={dressDropdownRef}>
                                            <div
                                                onClick={() => setShowDressCodeDropdown(!showDressCodeDropdown)}
                                                className="add-venue__form-block-group-input add-venue__form-block-group-input--special"
                                            >
                                                <p className="add-venue__form-block-group-input-text">
                                                    {selectedDress}
                                                </p>
                                                <img
                                                    className="add-venue__form-block-group-input-icon"
                                                    src={chevronDown}
                                                    alt="chevron down"
                                                ></img>
                                            </div>
                                            {showDressCodeDropdown && (
                                                <Dropdown
                                                    type={"radio"}
                                                    data={["Any", "Casual", "Upscale", "Beach attire"]}
                                                    setter={setSelectedDress}
                                                    valueSet={selectedDress}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="add-venue__form-block-group">
                                        <p className="add-venue__form-block-group-label">Music</p>
                                        <div ref={musicDropdownRef}>
                                            <div
                                                onClick={() => setShowMusicDropdown(!showMusicDropdown)}
                                                className="add-venue__form-block-group-input add-venue__form-block-group-input--special"
                                            >
                                                <p className="add-venue__form-block-group-input-text">
                                                    Choose music genre
                                                </p>
                                                <img
                                                    className="add-venue__form-block-group-input-icon"
                                                    src={chevronDown}
                                                    alt="chevron down"
                                                ></img>
                                            </div>
                                            {showMusicDropdown && (
                                                <Dropdown
                                                    type={"checkbox"}
                                                    data={["Latin", "R&B", "Rock", "EDM", "Dance", "Reggaeton", "Jazz"]}
                                                    setter={setSelectedMusic}
                                                    valueSet={selectedMusic}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="add-venue__form-block-about">
                                    <label htmlFor="venueAbout" className="add-venue__form-block-group-label">
                                        About
                                    </label>
                                    <textarea
                                        rows={4}
                                        name="venueAbout"
                                        className="add-venue__form-block-about-input"
                                        value={newVenueAbout}
                                        onChange={(event) => setNewVenueAbout(event.target.value)}
                                        placeholder="Enter venue description"
                                        required
                                    />
                                </div>

                                <button type="submit" className="add-user__form-button">
                                    <p className="add-user__form-button-text">Save Information</p>
                                    <img src={checkMark} alt="a checkmark"></img>
                                </button>
                            </section>

                            <section className="add-venue__form--right">
                                <div className="add-venue__form-photo">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={(event) => setProfilePic(event.target.files[0])}
                                    />
                                    <button
                                        type="button"
                                        className="add-venue__form-photo-button"
                                        onClick={handleFileUpload}
                                    >
                                        <img src={addPhoto} alt="click here to upload a file"></img>
                                    </button>
                                </div>
                            </section>
                        </form>
                    </section>
                </article>
            </div>
        </main>
    );
}

export default AddVenue;
